import { useState } from "react";
import { ChevronDown, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const CURRENCY_OPTIONS = [
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
  { code: 'CHF', symbol: 'Fr', name: 'Swiss Franc' },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  { code: 'CNY', symbol: '¥', name: 'Chinese Yuan' },
  { code: 'UAH', symbol: '₴', name: 'Ukrainian Hryvnia' },
  { code: 'BRL', symbol: 'R$', name: 'Brazilian Real' },
  { code: 'NZD', symbol: 'NZ$', name: 'New Zealand Dollar' },
  { code: 'HKD', symbol: 'HK$', name: 'Hong Kong Dollar' },
  { code: 'SGD', symbol: 'S$', name: 'Singapore Dollar' },
];

interface CurrencyChipProps {
  value: string;
  onChange: (currency: string) => void;
  className?: string;
}

export const CurrencyChip = ({ value, onChange, className = "" }: CurrencyChipProps) => {
  const [open, setOpen] = useState(false);
  
  const selectedCurrency = CURRENCY_OPTIONS.find(c => c.code === value) || { code: value, symbol: value, name: value };

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className={`h-7 px-2 text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted/50 ${className}`}
        >
          {selectedCurrency.code}
          <ChevronDown className="w-3 h-3 ml-1 opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-48 max-h-64 overflow-y-auto">
        {CURRENCY_OPTIONS.map((currency) => (
          <DropdownMenuItem
            key={currency.code}
            onClick={() => {
              onChange(currency.code);
              setOpen(false);
            }}
            className="flex items-center justify-between"
          >
            <span className="flex items-center gap-2">
              <span className="w-6 text-center font-medium">{currency.symbol}</span>
              <span>{currency.code}</span>
            </span>
            {value === currency.code && (
              <Check className="w-4 h-4 text-primary" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
